<!--
 Список отзывов
 @versions: all
 props:
  reviews - массив с ключами отзывов из переменной ReviewsList
  title - Заголовок (если есть)
  version - версия внешнего вида отзывов
  color - цвет кнопки Continue
-->

<template>
  <div class="reviews-wrapper">
    <h2
      v-if="title"
      class="title-24-800 text-center"
    >
      {{ title }}
    </h2>

    <div class="reviews">
      <template v-if="version === 'v1'">
        <ReviewItem
          v-for="review in reviewsList"
          :key="review"
          theme="light"
          :review="review"
          data-testid="review-item"
        />
      </template>
      <template v-if="version === 'v2'">
        <ReviewItemV2
          v-for="review in reviewsList"
          :key="review"
          :review="review"
          data-testid="review-item"
        />
      </template>
    </div>

    <base-button
      v-if="visibleReviewsCount < reviews.length"
      type="text"
      class="reviews__button"
      :class="[color]"
      data-testid="reviews-show-more-btn"
      @click="visibleReviewsCount++"
    >
      <span class="reviews__button-text">{{ $t(showMoreLabel || 'ed_pp1_show_more_button') }}</span>
    </base-button>
  </div>
</template>

<script lang="ts" setup>
import ReviewItem from '~/components/ReviewItem.vue';
import ReviewItemV2 from '~/components/ReviewItemV2.vue';

interface Props {
  reviews: number[]
  title?: string
  version: 'v1' | 'v2'
  color: 'blue' | 'red'
  showMoreLabel?: string
}

const props = defineProps<Props>();

const visibleReviewsCount = ref(3);
const reviewsList = computed((): number[] => {
  return props.reviews.slice(0, visibleReviewsCount.value);
});
</script>

<style lang="scss" scoped>
.reviews-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.reviews {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 24px;

  &__button {
    margin-top: 16px;
    padding: 0 !important;

    &.blue {
      color: $blue;
    }
  }

  &__button-text {
    color: inherit;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
  }
}
</style>
